import { render, staticRenderFns } from "./NavBarDispositivi.vue?vue&type=template&id=4e1dc1ad&scoped=true&"
import script from "./NavBarDispositivi.vue?vue&type=script&lang=js&"
export * from "./NavBarDispositivi.vue?vue&type=script&lang=js&"
import style0 from "./NavBarDispositivi.vue?vue&type=style&index=0&id=4e1dc1ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1dc1ad",
  null
  
)

export default component.exports